module.exports = __webpack_public_path__ + "images/e0f8d7587080a132c9b611b01485a05f-IMG_4489.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slides/bedroom/IMG_4489.jpg
// module id = ./src/assets/images/slides/bedroom/IMG_4489.jpg
// module chunks = 0